module.exports = __webpack_public_path__ + "img/ball_4.671554d1.png";